let _actions = [];
const observableActions = new Rx.BehaviorSubject(_actions);

/**
 * @ngdoc service
 * @name repositories.GdprActionsRepository
 *
 * @description
 * This class is used to save/add devices objects.
 */
const GdprActionsRepository = {

    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#replace
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored actions with provided data.
     *
     * @param {Array} data An array with new actions.
     */
    replace(data) {

        _actions = (data || []);
        observableActions.onNext(_actions);

    },

    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#getAll
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all actions from repository.
     *
     * @returns {Array} actions all actions from repository
     */
    getAll() {

        return _actions;

    },

    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#add
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to add a new action to repository.
     *
     * @param {object} action An action object.
     */
    add(action) {

        const indexOfActions = _actions
            .findIndex(_action => String(_action.id) === String(action.id));

        if (indexOfActions === -1) {

            _actions.push(action);

            observableActions.onNext(_actions);

        }

    },

    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#getObservable
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for actios repository.
     * @returns {Object} an observable object for actions repository.
     */
    getObservable() {

        return observableActions;

    },

};

export default GdprActionsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.gdprActionsRepository.js